import { createEvent } from './createEvent'

type ModelProperties = {
  id: string
  type: string
}

type ModelPageViewedProperties = ModelProperties & {
  state: string
}

export const modelPageViewed =
  createEvent<ModelPageViewedProperties>('Model Page Viewed')
export const modelCreated = createEvent<ModelProperties>('Model Created')

type ModelCopiedProperties = ModelProperties & {
  sourceId: string
}

export const modelCopied = createEvent<ModelCopiedProperties>('Model Copied')

type ModelTrainedProperties = ModelProperties & {
  configurationName: string | undefined
}

export const modelTrained = createEvent<ModelTrainedProperties>('Model Trained')
export const modelActivated = createEvent<ModelProperties>('Model Activated')
export const modelDeactivated =
  createEvent<ModelProperties>('Model Deactivated')
export const modelDeleted = createEvent<ModelProperties>('Model Deleted')
export const modelArchived = createEvent<ModelProperties>('Model Archived')
